export default __webpack_public_path__ + "static/media/header.fb0ba517.png";